<ngx-spinner bdColor="rgba(0, 0, 0, 0.1)" template=" <img src='assets/images/spinner.gif' />">
</ngx-spinner>

<div dir="{{languageDir}}">
    <div class="content-top-box">
        <app-bread-crumb></app-bread-crumb>
    </div>

    <div class="container">
        <mat-tab-group>
            <mat-tab>
                <ng-template mat-tab-label>
                    {{t('TaskPool', 'Task Pool')}}
                </ng-template>
                <header style="width: 100%; margin-top: 10px;">
                    <div class="year">
                        <!-- <h2>{{t('Year', 'Year')}} {{selectedYear}}</h2> -->
                        <button mat-flat-button color="accent" *ngIf="isWrite | permissionChecker"
                            [hidden]="selectedRowCount === 0" (click)="reScheduleTaskFromPool()">{{t('reschedule', 'Reschedule')}}</button>
                    </div>
                    <form [formGroup]="HeaderForm">
                        <div class="content-top-row content-top-row-order-processing w-100 d-flex justify-end">

                            <mat-form-field appearance="fill"
                                class="top-row-first-filed-item top-row-first-filed-item-order-processing">
                                <mat-label>{{t('line', 'Line')}}</mat-label>

                                <mat-select formControlName="line" multiple [compareWith]="compareFn"
                                    (selectionChange)="getMachineComponentAndTask()"
                                    (openedChange)="onPanelClose($event, 'line', lineSearchInput)">

                                    <!-- search input inside panel -->
                                    <input #lineSearchInput (keydown)="$event.stopPropagation()"
                                        (keyup)="searchValues($event, 'line')" class="form-control w-100"
                                        [placeholder]="t('SearchLines', 'Search Lines')">

                                    <mat-option *ngFor="let line of filteredLineList" [value]="line.lineId">
                                        {{line.lineDesc}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>


                            <mat-form-field appearance="fill"
                                class="top-row-first-filed-item top-row-first-filed-item-order-processing">
                                <mat-label>{{t('machine', 'Machine')}}</mat-label>
                                <mat-select formControlName="machine" multiple
                                    (selectionChange)="getMachineComponentAndTask()"
                                    (openedChange)="onPanelClose($event, 'machine', machineSearchInput)">
                                    <input #machineSearchInput (keydown)="$event.stopPropagation()"
                                        (keyup)="searchValues($event, 'machine')" class="form-control w-100"
                                        [placeholder]="t('SearchMachines', 'Search Machines')">
                                    <mat-option *ngFor="let machine of filteredMachineList" [value]="machine.unitId">
                                        {{machine.unitDesc}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>

                            <!-- Component Filter with Search -->
                            <mat-form-field appearance="fill"
                                class="top-row-first-filed-item top-row-first-filed-item-order-processing">
                                <mat-label>{{t('Component', 'Component')}}</mat-label>
                                <mat-select formControlName="component" multiple
                                    (selectionChange)="getMachineComponentAndTask()"
                                    (openedChange)="onPanelClose($event, 'component', componentSearchInput)">
                                    <input #componentSearchInput (keydown)="$event.stopPropagation()"
                                        (keyup)="searchValues($event, 'component')" class="form-control w-100"
                                        [placeholder]="t('SearchComponent', 'Search Component')">
                                    <mat-option *ngFor="let component of filteredComponentList"
                                        [value]="component.ComponentID">
                                        {{component.ComponentName}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>

                            <!-- Task Filter with Search -->
                            <mat-form-field appearance="fill"
                                class="top-row-first-filed-item top-row-first-filed-item-order-processing">
                                <mat-label>{{t('Task', 'Task')}}</mat-label>
                                <mat-select formControlName="task" multiple
                                    (openedChange)="onPanelClose($event, 'task', taskSearchInput)">
                                    <input #taskSearchInput (keydown)="$event.stopPropagation()"
                                        (keyup)="searchValues($event, 'task')" class="form-control w-100"
                                        [placeholder]="t('SearchTasks', 'Search Tasks')">
                                    <mat-option *ngFor="let task of filteredTaskList" [value]="task.Task_ID">
                                        {{task.Description}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>

                            <!-- Frequency Filter with Search -->
                            <mat-form-field appearance="fill"
                                class="top-row-first-filed-item top-row-first-filed-item-order-processing">
                                <mat-label>{{t('Frequency', 'Frequency')}}</mat-label>
                                <mat-select formControlName="frequency" multiple
                                    (openedChange)="onPanelClose($event, 'frequency', frequencySearchInput)">
                                    <input #frequencySearchInput (keydown)="$event.stopPropagation()"
                                        (keyup)="searchValues($event, 'frequency')" class="form-control w-100"
                                        [placeholder]="t('SearchFrequencies', 'Search Frequencies')">
                                    <mat-option *ngFor="let freq of filteredFrequencyList" [value]="freq.ID">
                                        {{freq.Name}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>

                        <div class="content-top-row content-top-row-order-processing w-100 d-flex justify-end">
                            <!-- Maintenance Type Filter with Search -->
                            <!-- <mat-form-field appearance="fill"
                                class="top-row-first-filed-item top-row-first-filed-item-order-processing">
                                <mat-label>{{t('MaintenanceType', 'Maintenance Type')}}</mat-label>
                                <mat-select formControlName="maintenance" multiple  
                                    (openedChange)="onPanelClose($event, 'maintenance', typeSearchInput)">
                                    <input #typeSearchInput (keyup)="searchValues($event, 'maintenance')"
                                        class="form-control w-100" [placeholder]="t('SearchMaintenanceTypes', 'Search Maintenance Types')">
                                    <mat-option *ngFor="let maintenance of FilteredMaintenanceType" [value]="maintenance.Name">
                                        {{maintenance.Name}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field> -->

                            <!-- Task Type Filter with Search -->
                            <mat-form-field appearance="fill"
                                class="top-row-first-filed-item top-row-first-filed-item-order-processing">
                                <mat-label>{{t('TaskType', 'Task Type')}}</mat-label>
                                <mat-select formControlName="type" multiple
                                    (openedChange)="onPanelClose($event, 'type', tasktypeSearchInput)">
                                    <input #tasktypeSearchInput (keydown)="$event.stopPropagation()"
                                        (keyup)="searchValues($event, 'type')" class="form-control w-100"
                                        [placeholder]="t('SearchTypes', 'Search Types')">
                                    <mat-option *ngFor="let type of filteredTypeList" [value]="type.ID">
                                        {{type.Name}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>

                            <!--Activity Type Filter with Search -->
                            <mat-form-field appearance="fill"
                                class="top-row-first-filed-item top-row-first-filed-item-order-processing">
                                <mat-label>{{t('ActivityType', 'Activity Type')}}</mat-label>
                                <mat-select formControlName="activity" multiple
                                    (openedChange)="onPanelClose($event, 'activity', typeSearchInput)">
                                    <input #typeSearchInput (keydown)="$event.stopPropagation()"
                                        (keyup)="searchValues($event, 'activity')" class="form-control w-100"
                                        [placeholder]="t('SearchTypes', 'Search Types')">
                                    <mat-option *ngFor="let activity of WOTypeFiltListHeaderForm" [value]="activity.ID">
                                        {{activity.Name}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>

                            <!-- Task Status Filter with Search -->
                            <mat-form-field appearance="fill"
                                class="top-row-first-filed-item top-row-first-filed-item-order-processing">
                                <mat-label>{{t('TaskStatus', 'Task Status')}}</mat-label>
                                <mat-select formControlName="taskStatus" multiple
                                    (openedChange)="onPanelClose($event, 'taskStatus', taskStatusSearchInput)">
                                    <input #taskStatusSearchInput (keydown)="$event.stopPropagation()"
                                        (keyup)="searchValues($event, 'taskStatus')" class="form-control w-100"
                                        [placeholder]="t('SearchTaskStatus', 'Search Task Status')">
                                    <mat-option *ngFor="let taskStatus of TaskStatusListFiltered"
                                        [value]="taskStatus.Name">
                                        {{taskStatus.Name}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                            <!-- Task Status Filter with Search -->
                            <mat-form-field appearance="fill"
                                class="top-row-first-filed-item top-row-first-filed-item-order-processing">
                                <mat-label>{{t('SearchTechnician', 'Search Technician')}}</mat-label>
                                <mat-select formControlName="userTechnician" multiple
                                    (openedChange)="onPanelClose($event, 'tech', techSearchInput)">
                                    <input #techSearchInput (keydown)="$event.stopPropagation()"
                                        (keyup)="searchValues($event, 'tech')" class="form-control w-100"
                                        [placeholder]="t('SearchTechnicians', 'Search Technicians')">
                                    <mat-option *ngFor="let tech of filteredTechnicianList" [value]="tech.employeeCode">
                                        {{tech.fullName}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>

                            <mat-form-field class="top-row-first-filed-item top-row-first-filed-item-order-processing"
                                style="width: 20%">

                                <mat-label>
                                    {{
                                    (langObj?.Start ? langObj.Start : ('' | translate)) +
                                    ' - ' +
                                    (langObj?.End ? langObj.End : ('' | translate))
                                    }}
                                </mat-label>

                                <mat-date-range-input [rangePicker]="picker">
                                    <input matStartDate formControlName="dateRange"
                                        [placeholder]="langObj?.Start || ('Start' | translate)" [readOnly]="true" />

                                    <input matEndDate formControlName="endDate"
                                        [placeholder]="langObj?.End || ('End' | translate)" [readOnly]="true" />
                                </mat-date-range-input>

                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-date-range-picker #picker></mat-date-range-picker>

                            </mat-form-field>
                            <button mat-flat-button color="accent" style="border-radius: 1rem;"
                                (click)="applyFilters()">{{t('ApplyFilter', 'Apply Filter')}}</button>
                        </div>
                    </form>
                </header>
                <ag-grid-angular style="width: 100%; height: 24vw; margin-top: 20px;" class="ag-theme-alpine"
                    [rowData]="rowPoolData" [columnDefs]="columnDefs" (gridReady)="onGridReady($event)"
                    (cellClicked)="cellClicked($event)" [gridOptions]="gridOptions" [pagination]="true"
                    [paginationPageSize]="10" (selectionChanged)="onRowSelectionChange()">
                </ag-grid-angular>


                <!-- <table border="1">
                    <thead>
                        <tr>
                            <th>Machine</th>
                            <th>TaskExpireTime</th>
                            <th>Task Description</th>
                            <th>Task Technician</th>
                            <th>NextScheduleAt</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of taskList">
                            <td>{{ item.Machine }}</td>
                            <td>{{ item.TaskExpireTime }}</td>
                            <td>{{ item.Task.Description }}</td>
                            <td>{{ item.Task.Technician }}</td>
                            <td>{{ item.Task.NextScheduleAt }}</td>
                        </tr>
                    </tbody>
                </table> -->
            </mat-tab>
            <mat-tab>
                <ng-template mat-tab-label>
                    {{t('MaintenanceCalendar', 'Maintenance Calendar')}}
                </ng-template>
                <header style="width: 100%;margin-top: 10px;">
                    <div class="year">
                        <h2>{{t('Year', 'Year')}} {{selectedYear}}</h2>
                    </div>
                    <form [formGroup]="HeaderForm">
                        <div class="content-top-row content-top-row-order-processing w-100">

                            <mat-form-field appearence="fill"
                                class="top-row-first-filed-item top-row-first-filed-item-order-processing">
                                <mat-select formControlName="technician" [(ngModel)]="headerData.technician"
                                    placeholder="{{t('SelectTechnician', 'Select Technician')}}"
                                    name="technician" (selectionChange)="getTaskList()">
                                    <input (keyup)="searchValues($event, 'technician')" class="form-control w-100"
                                        placeholder="{{t('SearchTechnician', 'Search Technician')}}">
                                    <mat-option value="ALL">{{t('All', 'All')}}</mat-option>
                                    <mat-option *ngFor="let tech of filteredTechnicianList" [value]="tech.employeeCode">
                                        {{tech.fullName}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>

                            <mat-form-field class="top-row-first-filed-item top-row-first-filed-item-order-processing">
                                <mat-select formControlName="year" [(ngModel)]="selectedYear" [placeholder]="t('SelectYear', 'Select Year')"
                                    name="year" (selectionChange)="onYearChange($event)">
                                    <mat-option *ngFor="let year of yearList" [value]="year">{{ year }}</mat-option>
                                </mat-select>
                            </mat-form-field>


                            <div *ngIf="headerData.WeekMonth == 1 && weekScheduleTaskColumns && weekScheduleTaskColumns.length"
                                class="week-btns">
                                <!-- <h4>Week</h4> -->
                                <button type="button" (click)="changeWeek(i)" [ngClass]="{'bg-success':weekIndex == i}"
                                    class="nav-button" tooltipPosition="top"
                                    *ngFor="let week of weekScheduleTaskColumns; let i = index">{{ i+1 }}
                                </button>
                            </div>

                            <mat-form-field appearence="fill"
                                class="top-row-first-filed-item top-row-first-filed-item-order-processing">
                                <mat-select formControlName="curmonth" [(ngModel)]="currentMonth"
                                    placeholder="{{t('MonthList', 'Month List')}}"
                                    name="month" (selectionChange)="onMonthChange($event)">
                                    <mat-option *ngFor="let month of monthNames" [value]="month">{{month}}</mat-option>
                                </mat-select>
                            </mat-form-field>

                            <!-- <mat-form-field appearence="fill"
                            class="top-row-first-filed-item top-row-first-filed-item-order-processing">
                            <mat-select formControlName="curmonth" [(ngModel)]="currentMonth" placeholder="{{t('MonthList', 'Month List')}}"
                                name="month" (selectionChange)="getTaskList()">
                                <mat-option *ngFor="let month of monthNames" [value]="month">
                                    {{month}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field> -->
                            <mat-form-field appearence="fill"
                                class="top-row-first-filed-item top-row-first-filed-item-order-processing">
                                <mat-select formControlName="wkmonth" [(ngModel)]="headerData.WeekMonth"
                                    placeholder="{{t('WeekMonth', 'Week / Month')}}"
                                    panelClass="testClass" name="WeekMonth" (selectionChange)="changeCalendar()">
                                    <mat-select-filter [placeholder]="'Search'" [displayMember]="'value'"
                                        [array]="calTypeList"
                                        (filteredReturn)="filteredCalTypeList = $event"></mat-select-filter>
                                    <mat-option *ngFor="let calType of filteredCalTypeList" [value]="calType.id">
                                        {{calType.value}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </form>
                </header>
                <div class="table-container">
                    <div class="schedule-table">
                        <table *ngIf="scheduleTaskColumns && scheduleTaskColumns[0]">
                            <thead>
                                <tr>
                                    <th *ngFor="let column of scheduleTaskColumns[0];let i=index"
                                        [ngClass]="{'bg-color-weekoff': column.weekOff }">{{ column.date }}</th>
                                </tr>
                                <tr>
                                    <th *ngFor="let column of scheduleTaskColumns[0];let i=index"
                                        [ngClass]="{'bg-color-weekoff': column.weekOff }">{{
                                        column.day }}</th>
                                </tr>
                            </thead>
                            <tbody *ngIf="(taskRow && taskRow[0]) && (isUpdate | permissionChecker)">
                                <tr *ngFor="let row of taskRow[0]; let i = index"
                                    [ngClass]="{ 'bg-success': i%2 != 0 }">
                                    <td *ngFor="let column of scheduleTaskColumns[0];let j=index" #tooltip="matTooltip"
                                        (click)="column.task && column.task[row] && reScheduleTask(row, column)"
                                        [matTooltip]="column.task && column.task[row] ? (column.task[row].Status ? 'Completed' : 'Open') : ''"
                                        [ngClass]="{'text-danger': column.task && column.task[row] && !column.task[row].Status, 'text-success': column.task && column.task[row] && column.task[row].Status ,'low-opacity': column.fullDate < currentDate}">
                                        {{ column.task && column.task[row] ? ((column.task[row].Task.WOType ?
                                        column.task[row].Task.WOType.Name : '') + ' - ' +
                                        column.task[row].Task.Duration) + 'Min' : '' }} <br>
                                        {{ column.task && column.task[row] ? column.task[row].Task.units.puDesc : '' }}
                                    </td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr></tr>
                            </tfoot>
                        </table>
                        <table *ngIf="scheduleTaskColumns && scheduleTaskColumns[1]">
                            <thead>
                                <tr>
                                    <th *ngFor="let column of scheduleTaskColumns[1];let i=index"
                                        [ngClass]="{'bg-color-weekoff': column.weekOff }">{{ column.date }}</th>
                                </tr>
                                <tr>
                                    <th *ngFor="let column of scheduleTaskColumns[1];let i=index"
                                        [ngClass]="{'bg-color-weekoff': column.weekOff }">{{
                                        column.day }}</th>
                                </tr>
                            </thead>
                            <tbody *ngIf="(taskRow && taskRow[1]) && (isUpdate | permissionChecker)">
                                <tr *ngFor="let row of taskRow[1]; let i = index"
                                    [ngClass]="{ 'bg-success': i%2 != 0 }">
                                    <td *ngFor="let column of scheduleTaskColumns[1];let j=index" #tooltip="matTooltip"
                                        (click)="column.task && column.task[row] && reScheduleTask(row, column)"
                                        [matTooltip]="column.task && column.task[row] ? (column.task[row].Status ? 'Completed' : 'Open') : ''"
                                        [ngClass]="{'text-danger': column.task && column.task[row] && !column.task[row].Status, 'text-success': column.task && column.task[row] && column.task[row].Status ,'low-opacity': column.fullDate < currentDate}">
                                        {{ column.task && column.task[row] ? ((column.task[row].Task.WOType ?
                                        column.task[row].Task.WOType.Name : '') + ' - ' +
                                        column.task[row].Task.Duration) + 'Min' : '' }} <br>
                                        {{ column.task && column.task[row] && column.task[row].Task &&
                                        column.task[row].Task.units ? column.task[row].Task.units.puDesc : '' }}
                                    </td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr></tr>
                            </tfoot>
                        </table>
                        <table *ngIf="scheduleTaskColumns && scheduleTaskColumns[2]">
                            <thead>
                                <tr>
                                    <th *ngFor="let column of scheduleTaskColumns[2];let i=index"
                                        [ngClass]="{'bg-color-weekoff': column.weekOff }">{{ column.date }}</th>
                                </tr>
                                <tr>
                                    <th *ngFor="let column of scheduleTaskColumns[2];let i=index"
                                        [ngClass]="{'bg-color-weekoff': column.weekOff }">{{
                                        column.day }}</th>
                                </tr>
                            </thead>
                            <tbody *ngIf="(taskRow && taskRow[2]) && (isUpdate | permissionChecker)">
                                <tr *ngFor="let row of taskRow[2]; let i = index"
                                    [ngClass]="{ 'bg-success': i%2 != 0 }">
                                    <td *ngFor="let column of scheduleTaskColumns[2];let j=index" #tooltip="matTooltip"
                                        (click)="column.task && column.task[row] && reScheduleTask(row, column)"
                                        [matTooltip]="column.task && column.task[row] ? (column.task[row].Status ? 'Completed' : 'Open') : ''"
                                        [ngClass]="{'text-danger': column.task && column.task[row] && !column.task[row].Status, 'text-success': column.task && column.task[row] && column.task[row].Status ,'low-opacity': column.fullDate < currentDate}">
                                        {{ column.task && column.task[row] ? ((column.task[row].Task.WOType ?
                                        column.task[row].Task.WOType.Name : '') + ' - ' +
                                        column.task[row].Task.Duration) + 'Min' : '' }} <br>
                                        {{ column.task && column.task[row] ? column.task[row].Task.units.puDesc : '' }}
                                    </td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr></tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            </mat-tab>
        </mat-tab-group>

    </div>

    <ng-template #pmTaskForm>
        <div mat-dialog-title class="mat-title">
            <div class="d-flex justify-content-between align-items-center">
                <h1 class="main-title">{{t('AddPMTask', 'Add PM Task')}}</h1>
                <button mat-mini-fab mat-button mat-dialog-close color="warn" *ngIf="isWrite | permissionChecker"
                    [title]="t('Close', 'Close')">
                    <i class="fa fa-times" style="color: #fff"></i>
                </button>
            </div>
        </div>
        <div class="col-md-12">
            <div class="wrapper-box wrapper-box-shadow table-wrapper">
                <form [formGroup]="PMTaskForm" (ngSubmit)="TaskOnSubmit()">
                    <div class="content-top-row prevForm">
                        <mat-form-field class="w-22">
                            <mat-select formControlName="group" (selectionChange)="getPlants(PMTask.Group)"
                                placeholder="{{t('Group', 'Group')}}"
                                [(ngModel)]="PMTask.Group">
                                <mat-select-filter [placeholder]="'Search'" [displayMember]="'name'" [array]="groupList"
                                    (filteredReturn)="groupFiltList = $event">
                                </mat-select-filter>
                                <mat-option *ngFor="let group of groupFiltList" [value]="group.id">
                                    {{group.name}}
                                </mat-option>
                            </mat-select>
                            <mat-error>{{t('GroupisRequired', 'Group is required')}}</mat-error>
                        </mat-form-field>
                        <!-- Plant -->
                        <mat-form-field class="w-22">
                            <mat-select formControlName="plant" [(ngModel)]="PMTask.Plant"
                                placeholder="{{t('Plant', 'Plant')}}"
                                (selectionChange)="getPMTaskData('change')">
                                <mat-select-filter [placeholder]="'Search'" [displayMember]="'name'" [array]="plantList"
                                    (filteredReturn)="plantFiltList = $event">
                                </mat-select-filter>
                                <mat-option *ngFor="let plant of plantFiltList" [value]="plant.id">
                                    {{plant.name}}
                                </mat-option>
                            </mat-select>
                            <mat-error>{{t('PlantisRequired', 'Plant is required')}}</mat-error>
                        </mat-form-field>

                        <mat-form-field appearence="fill" class="w-22">
                            <mat-label>{{t('Line', 'Line')}}</mat-label>
                            <mat-select formControlName="line" [(ngModel)]="PMTask.line" name="Line"
                                (selectionChange)="setUnitList('change')">
                                <mat-select-filter [placeholder]="'Search Line'" [displayMember]="'PL_Desc'"
                                    [array]="LineList" (filteredReturn)="LineFilterList = $event">
                                </mat-select-filter>
                                <mat-option *ngFor="let line of LineFilterList" [value]="line.PL_Id">
                                    {{ line.PL_Desc }}
                                </mat-option>
                            </mat-select>
                            <mat-error>{{t('LineisRequired', 'Line is required')}}</mat-error>
                        </mat-form-field>
                        <mat-form-field appearence="fill" class="w-22" style="margin: 0;">
                            <mat-label>{{t('Unit', 'Unit')}}</mat-label>
                            <mat-select formControlName="unit" [(ngModel)]="PMTask.units" name="Unit"
                                (selectionChange)="setAssemblyList('change')">
                                <mat-select-filter [placeholder]="'Search Unit'" [displayMember]="'PU_Desc'"
                                    [array]="UnitList" (filteredReturn)="UnitFilterList = $event">
                                </mat-select-filter>
                                <mat-option *ngFor="let unit of UnitFilterList" [value]="unit.PU_Id">
                                    {{ unit.PU_Desc }}
                                </mat-option>
                            </mat-select>
                            <mat-error>{{t('UnitisRequired', 'Unit is required')}}</mat-error>
                        </mat-form-field>

                    </div>
                    <div class="content-top-row prevForm">
                        <mat-form-field appearence="fill" class="w-22">
                            <mat-label>{{t('Assembly', 'Assembly')}}</mat-label>
                            <mat-select formControlName="assembly" [(ngModel)]="PMTask.assembly" name="Assembly"
                                (selectionChange)="setSubAssemblyList('change')">
                                <mat-select-filter [placeholder]="'Search Assembly'" [displayMember]="'Assbly_Desc'"
                                    [array]="AssemblyList" (filteredReturn)="AssemblyFilterList = $event">
                                </mat-select-filter>
                                <mat-option *ngFor="let assembly of AssemblyFilterList" [value]="assembly.Assbly_Id">
                                    {{ assembly.Assbly_Desc }}
                                </mat-option>
                            </mat-select>
                            <mat-error>{{t('AssemblyisRequired', 'Assembly is required')}}</mat-error>
                        </mat-form-field>
                        <mat-form-field appearence="fill" class="w-22">
                            <mat-label>{{t('SubAssembly', 'Sub Assembly')}}</mat-label>
                            <mat-select formControlName="subAssembly" [(ngModel)]="PMTask.subAssembly"
                                name="Sub Assembly" (selectionChange)="setComponentList('change')">
                                <mat-select-filter [placeholder]="'Search Sub Assembly'" [displayMember]="'SAsbly_Desc'"
                                    [array]="SubAssemblyList" (filteredReturn)="SubAssemblyFilterList = $event">
                                </mat-select-filter>
                                <mat-option *ngFor="let subAssembly of SubAssemblyFilterList"
                                    [value]="subAssembly.SAssbly_Id">
                                    {{ subAssembly.SAsbly_Desc }}
                                </mat-option>
                            </mat-select>
                            <mat-error>{{t('SubAssemblyisRequired', 'Sub assembly is required')}}</mat-error>
                        </mat-form-field>
                        <mat-form-field appearence="fill" class="w-22">
                            <mat-label>{{t('Component', 'Component')}}</mat-label>
                            <mat-select formControlName="component" [(ngModel)]="PMTask.component" name="Component">
                                <mat-select-filter [placeholder]="'Search Component'" [displayMember]="'ComponentName'"
                                    [array]="ComponentList" (filteredReturn)="ComponentFilterList = $event">
                                </mat-select-filter>
                                <mat-option *ngFor="let component of ComponentFilterList"
                                    [value]="component.ComponentId">
                                    {{ component.ComponentName }}
                                </mat-option>
                            </mat-select>
                            <mat-error>{{t('ComponentisRequired', 'Component is required')}}</mat-error>
                        </mat-form-field>

                        <mat-form-field class="w-22" style="margin: 0;">
                            <mat-label>{{t('Description', 'Description')}}</mat-label>
                            <input matInput type="text" formControlName="description"
                                [(ngModel)]="PMTask.Description" />
                            <mat-error>{{t('DescriptionisRequired', 'Description is required')}} </mat-error>
                        </mat-form-field>

                        <app-unit-picker [Group]="PMTask.Group" (emitSelectedUnit)="setUnit($event)"
                            [unitPickerIsOpen]="unitPickerIsOpen" [isPickFromUnit]="isPickFromUnit"></app-unit-picker>

                    </div>
                    <div class="content-top-row prevForm">

                        <mat-form-field class="w-22">
                            <mat-label>{{t('SelectTechnicians', 'Select Technicians')}}</mat-label>
                            <mat-select [(ngModel)]="PMTask.Technician" formControlName="technicians">
                                <mat-select-filter [placeholder]="'Search'" [displayMember]="'UserName'"
                                    [array]="filterTechnicianList" (filteredReturn)="TechnicianFiltList = $event">
                                </mat-select-filter>
                                <mat-option *ngFor="let technician of TechnicianFiltList" [value]="technician.UserId">
                                    {{technician.UserName}}
                                </mat-option>
                            </mat-select>
                            <mat-error>{{t('TechnicianisRequired', 'Technician is required')}} </mat-error>
                        </mat-form-field>

                        <mat-form-field class="w-22">
                            <mat-label>{{t('SelectTaskType', 'Select Task Type')}}</mat-label>
                            <mat-select [(ngModel)]="PMTask.TaskType" formControlName="task_type"
                                (selectionChange)="setMaintenanceType()">
                                <mat-select-filter [placeholder]="'Search'" [displayMember]="'Name'"
                                    [array]="TaskTypeList" (filteredReturn)="TaskTypeFiltList = $event">
                                </mat-select-filter>
                                <mat-option *ngFor="let taskType of TaskTypeFiltList" [value]="taskType.ID">
                                    {{taskType.Name}}
                                </mat-option>
                            </mat-select>
                            <mat-error>{{t('TaskTypeisRequired', 'Task type is required')}}</mat-error>
                        </mat-form-field>

                        <mat-form-field class="w-22">
                            <mat-label>{{t('SelectFrequency', 'Select Frequency')}}</mat-label>
                            <mat-select [(ngModel)]="PMTask.Frequency" formControlName="frequency"
                                (selectionChange)="setFrequencyDuration()">
                                <mat-select-filter [placeholder]="'Search'" [displayMember]="'Name'"
                                    [array]="frequencyList" (filteredReturn)="FrequencyFiltList = $event">
                                </mat-select-filter>
                                <mat-option *ngFor="let frequency of FrequencyFiltList" [value]="frequency.ID">
                                    {{frequency.Name}}
                                </mat-option>
                            </mat-select>
                            <mat-error>{{t('FrequencyisRequired', 'Frequency is required')}}</mat-error>
                        </mat-form-field>

                        <mat-form-field class="w-22" style="margin: 0;">
                            <mat-label>{{t('ActivityType', 'Activity Type')}}</mat-label>
                            <mat-select [(ngModel)]="PMTask.WOType" formControlName="WOType">
                                <mat-select-filter [placeholder]="'Search'" [displayMember]="'Name'"
                                    [array]="WOTypeList" (filteredReturn)="WOTypeFiltList = $event">
                                </mat-select-filter>
                                <mat-option *ngFor="let technology of WOTypeFiltList" [value]="technology.ID">
                                    {{technology.Name}}
                                </mat-option>
                            </mat-select>
                            <mat-error>{{t('ActivityTypeisRequired', 'Activity type is required')}} </mat-error>
                        </mat-form-field>


                    </div>

                    <div class="content-top-row prevForm">
                        <mat-form-field class="w-22">
                            <mat-label>{{t('Duration', 'Duration')}}</mat-label>
                            <input matInput matInput type="number" formControlName="type_duration"
                                [(ngModel)]="PMTask.Duration" />
                            <span matSuffix class="min"> / hrs</span>
                            <mat-error>{{t('DurationisRequired', 'Duration is required')}}
                            </mat-error>
                        </mat-form-field>

                        <mat-form-field class="w-22">
                            <mat-label>{{t('SparePartsCode', 'Spare Parts Code')}}</mat-label>
                            <input matInput formControlName="spare_part" [(ngModel)]="PMTask.SpareParts" />
                            <mat-error>{{t('SpareCodeisRequired', 'Spare code is required')}}</mat-error>
                        </mat-form-field>

                        <mat-form-field class="w-22">
                            <mat-label>{{t('MaintenanceType', 'Maintenance Type')}}</mat-label>
                            <mat-select [(ngModel)]="PMTask.MaintenanceType" formControlName="maintenanceType" disabled>
                                <mat-option *ngFor="let mtype of MaintenanceType" [value]="mtype.Name">
                                    {{mtype.Name}}
                                </mat-option>
                            </mat-select>
                            <mat-error>{{t('MaintenanceTypeisRequired', 'Maintenance type is required')}}</mat-error>
                        </mat-form-field>

                        <mat-form-field class="w-22" style="margin: 0;">
                            <mat-label>{{t('FromTaskDate', 'From Task Date')}}</mat-label>
                            <input matInput [matDatepicker]="picker" formControlName="fromTaskDate"
                                [(ngModel)]="PMTask.FromTaskDate">
                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-datepicker #picker></mat-datepicker>
                            <mat-error>{{t('FromTaskDateisRequired', 'From task date is required')}}</mat-error>
                        </mat-form-field>

                    </div>

                    <div class="content-top-row prevForm" style="justify-content: flex-end;">

                        <div style="width: 23.5%;justify-content: space-between;display: flex;align-items: center;">
                            <button mat-flat-button color="accent" type="button" *ngIf="isWrite | permissionChecker"
                                class="upload" (click)="openFile()">
                                {{t('UploadFile', 'Upload File')}}</button>
                            <input type="file" (change)="readFile($event)" class="d-none" #fileInput multiple>

                            <button class="add-btn1" type="submit" *ngIf="isWrite | permissionChecker" [pTooltip]="t('Save', 'Save')"
                                tooltipPosition="right">
                                <img src="assets/images/save.png" alt="" width="20px" height="20px">
                            </button>
                        </div>
                    </div>

                    <div *ngIf="FileData && FileData.length" class="imgflex">
                        <div *ngFor="let file of FileData; let i = index" class="relative">
                            <div>
                                <img *ngIf="file.FileType == 'image'" [src]="file.ImageSrc" alt="" width="250px"
                                    height="200px">

                                <video *ngIf="file.FileType == 'video'" width="250" height="200" controls>
                                    <source [src]="file.ImageSrc" type="video/mp4">
                                    {{t('Yourbrowserdoesnotsupportthevideotag', 'Your browser does not support the video tag.')}}
                                </video>

                                <a *ngIf="file.FileType == 'application'" [href]="file.ImageSrc" target="_blank"
                                    download>
                                    <img src="./assets/images/show-pdf2.png" width="200" height="200" alt="pdf">
                                </a>
                            </div>

                            <img src="./assets/images/remove.png" (click)="removeFile(i)" class="absolute" alt=""
                                width="20px" height="20px">

                        </div>
                    </div>

                </form>
            </div>
        </div>
    </ng-template>
</div>